import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DialogDisclosure, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {useDialogContext, useDialogStore} from '@ariakit/react'
import {SubmitErrorHandler, useFormContext} from 'react-hook-form'
import {EditGenericEventFormValidationSchema} from '../../formSchemas'
import {useState} from 'react'
import {AgendaEditGenericEventConfirmationDialog} from '../agenda-event-form/agenda-edit-generic-event-confirmation-dialog/AgendaEditGenericEventConfirmationDialog'

export const EditGenericEventFormDialogFooter = () => {
    const {t} = useTranslation()
    const {handleSubmit, getValues} = useFormContext<EditGenericEventFormValidationSchema>()

    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false)

    const dialog = useDialogContext()
    const confirmationDialog = useDialogStore({
        open: isConfirmationDialogOpen,
        setOpen: setIsConfirmationDialogOpen
    })

    const handleUpdateEvent = () => {
        confirmationDialog.show()
    }

    const handleUpdateEventError: SubmitErrorHandler<EditGenericEventFormValidationSchema> = errors => {
        console.error(errors, {values: getValues()})
    }

    const onSubmit = handleSubmit(handleUpdateEvent, handleUpdateEventError)

    const handleSuccess = () => {
        dialog?.hide()
    }

    return (
        <DialogFooter>
            <div />
            <Flexbox gap={2}>
                <DialogDisclosure store={dialog} render={<Button variant="secondary">{t('commons:cancel')}</Button>} />
                <Button variant="primaryNeutral" onClick={onSubmit}>
                    {t('commons:save')}
                </Button>
                {isConfirmationDialogOpen && (
                    <AgendaEditGenericEventConfirmationDialog
                        confirmationDialog={confirmationDialog}
                        defaultValues={getValues()}
                        parentOnSuccess={handleSuccess}
                    />
                )}
            </Flexbox>
        </DialogFooter>
    )
}
